import { API_URL_V3 } from 'constants/config';
import type { Payment } from 'models/payment';
import { fetchWithAuthentication } from 'utils/fetchJson/fetchJson';

import type { CreatePaymentRequestBody } from './types';

export interface PaymentsService {
  create: (payload: CreatePaymentRequestBody) => Promise<Payment>;
}

export const payments: PaymentsService = {
  create: ({
    orderId,
    token,
    locale = 'en',
    hideUserManagement = false,
    captchaResponse,
    platform,
    recipient,
    whatsappNotification,
  }) => {
    const queryParams = [
      `token=${token}`,
      `locale=${locale}`,
      ...(hideUserManagement ? ['hideUserManagement=true'] : []),
      ...(recipient === 'PTU' ? ['avoid_maintenance=true'] : []),
    ].join('&');
    const path = `${API_URL_V3}/orders/${orderId}/payments?${queryParams}`;
    const body = JSON.stringify({
      ...{ captcha_response: captchaResponse },
      platform,
      recipient,
      ...(whatsappNotification != null && {
        whatsapp_notification: whatsappNotification,
      }),
    });
    const options = { method: 'POST', body };

    return fetchWithAuthentication(path, options);
  },
};
